import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <>
      {[1, 2, 3, 4, 5].map((i) => (
        <Box key={i} sx={{ mb: 4 }}>
          <Skeleton variant="text" width={'25%'} sx={{ mb: 1 }} />
          <Skeleton variant="rounded" width={'100%'} height={72} />
        </Box>
      ))}
    </>
  )
}

Loading.displayName = 'Loading'

export default Loading
